import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import LineItemSearchView from '../views/LineItemSearchView.vue'
import KitsView from '../views/KitsView.vue'
import JobStatusView from '../views/JobStatusView.vue'
import WebOrdersView from '../views/WebOrdersView.vue'
import LineItemsView from '../views/LineItemsView.vue'
import WebOrderDetailsView from '../views/WebOrderDetailsView.vue'
import WebOrderLineItemsView from '../views/WebOrderLineItemsView.vue'
import UserManagementView from '../views/UserManagementView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import axios from 'axios'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresGuest: true }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView
  },
  {
    path: '/order-new-part',
    name: 'order-new-part',
    component: LineItemSearchView,
    meta: { requiresAuth: true }
  },
  {
    path: '/kits',
    name: 'kits',
    component: KitsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/job-status',
    name: 'job-status',
    component: JobStatusView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/kits/:kitId/line-items',
    name: 'kit-line-items',
    component: LineItemsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/weborders',
    name: 'weborders',
    component: WebOrdersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lineitems',
    name: 'lineitems',
    component: LineItemsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/weborders/:id',
    name: 'WebOrderDetails',
    component: WebOrderDetailsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/weborderlineitems/:id',
    name: 'WebOrderLineItems',
    component: WebOrderLineItemsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/user-management',
    name: 'user-management',
    component: UserManagementView,
    meta: { 
      requiresAuth: true,
      requiresAdmin: true 
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  // Skip auth check for reset password route
  if (to.path === '/reset-password') {
    next()
    return
  }

  try {
    // Check authentication status
    const response = await axios.get('/auth/check-auth')
    const user = response.data.user

    // If user is authenticated and tries to access guest-only routes (login/register)
    if (requiresGuest) {
      next('/weborders')
      return
    }

    // If route requires auth
    if (requiresAuth) {
      if (requiresAdmin && user.role !== 'Admin') {
        next('/')
      } else {
        next()
      }
    } else {
      next()
    }
  } catch (error) {
    // If auth check fails and route requires auth, redirect to login
    if (requiresAuth) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
